import * as React from "react";
import {
  Text,
  View,
  Image,
  StyleSheet,
  TouchableOpacity,
  TouchableWithoutFeedback,
} from "react-native";

import GlobalStyles from "../components/GlobalStyles";
const BGimage = require("../assets/res/blue_bg.png");
const sparkle = require("../assets/res/sparkle.png");
export default function CharitySelectPopup(props) {
  return (
    <View style={GlobalStyles.containerW}>
      <View style={GlobalStyles.backgroundContainer}>
          <Image style={GlobalStyles.backgroundImage} source={BGimage} />
      </View>
      <View style={styles.modalContainerF}>
        <View style={styles.modalContainer}>
          <View>
            <View style={GlobalStyles.headerTextP}>
              <View style={styles.headerTextP}>
                <View>
                  <Text style={styles.textStyleHeader}>Awesome!</Text>
                  <Text style={styles.textStyleHeader}>
                    Thanks for donating.
                  </Text>
                </View>
                <View style={styles.buttonContainer}>
                  <TouchableOpacity
                    style={styles.SubmitButtonStyle}
                    activeOpacity={0.5}
                    onPress={() => disableCharityThanksModal()}
                  >
                    <Text style={styles.textStyleCont}>CONTINUE</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        </View>
        <Image style={styles.sparkle} source={sparkle} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  modalContainer: {
    height: 160,
    backgroundColor: "#FFC72C",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 60,
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
    marginLeft: 15,
    marginRight: 15,
    paddingTop: 30,
  },
  modalContainerF: {
    marginTop: 150,
    paddingTop: 20,
    marginLeft: 15,
    marginRight: 15,
  },

  textStyleHeader: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginLeft: -15,
  },

  textStyle: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 16,
    marginBottom: 10,
  },
  sparkle: {
    position: "absolute",
    top: 0,
    right: 0,
  },

  SubmitButtonStyle: {
    //marginTop: 10,
    paddingTop: 22,
    paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxWidth: "45%",
    alignContent: "center",
  },

  textStyleCont: {
    color: "#000000",
    textAlign: "center",
    alignSelf: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
  },

  buttonContainer: {
    width: "100%",
    position: "absolute",
    left: 20,
    bottom: -85,
  },
});
